define('features/vehicle-info/vehicle-benefits',[
  'jquery',
  'tdaUtils',
  'storageUtil',
  'txt!./vehicle.benefits.modal.hbs',
  'lib/util/langFromUrl',
  'googlemaps',

  // side effect includes
  'lib/helpers/replaceDisclaimer',
  'lib/helpers/replace',
  'dropkick',
], function (
  $,
  tdaUtils,
  storageUtil,
  txtBenefitsModal,
  langFromUrl,
  googleMaps
) {
  var __tmplBenefitsModal = Handlebars.compile(txtBenefitsModal);

  /* Handles the setup of the "Prius Prime Benefits area on Vehicle Info pages */
  var VehicleBenefits = function VehicleBenefits() {};

  VehicleBenefits.prototype = {
    cache: {
      national: {}

    },
    init: function () {
      this.noStateDetected = false;
    },

    createBenefitsModal: function () {
      var that = this;
      var incentiveModalContent = that.getContent('PriusPrimeIncentivesModal')
        .done(function (responseObj) {
          console.log('PriusPrimeIncentivesModal responseObj', responseObj);
          var modalHtml = __tmplBenefitsModal({ cobj: responseObj });
          $('#js-template-benefits-modal-output').html(modalHtml);

          // SEARCH INPUT CAPTURE, disable letters etc.
          $('#searchValueModal').on('keypress', function (key) {
            $('#search-state').val('SELECT_STATE').dropkick('refresh');
            $('#searchValueModal').removeClass('invalidInput');
            $('#searchValueModal').removeClass('validInput');
            if (key.charCode < 48 || key.charCode > 57) return false;
          });

          // BAT-3258 UPDATE FEDERAL INCENTIVE LINKS with datalayer goodness.
          var linkItems = $('#federalIncentivesList .col-sm-10 span').find('a');
          linkItems.each(function (idx, item) {
            $(item).addClass('datalayer-link');
          });

          // CREATE STATE DROP DOWN:
          var $stateSelect = $('#search-state');
          var allStates = tdaUtils.getAllStates('all');
          var options = '';
          options += '<option value="SELECT_STATE">' + responseObj.content.selectStateLabel + '</option>';
          for (var state in allStates) {
            options += '<option value="' + allStates[state] + '">' + state + '</option>';
          };
          $stateSelect.append(options);

          // DROP KICK THE STATES:
          if ($stateSelect.length) {
            var dk_state = $stateSelect.dropkick({
              mobile: true
            });
            dk_state.change(function () {
              $('#searchValueModal').removeClass('invalidInput');
              $('#searchValueModal').removeClass('validInput');
              $('#searchValueModal').val('');
              VehicleBenefits.selectedStateAbbr = $(this).val();
            });
          }
          // IF EXTRA HANDLING THE CLOSE EVENT OF THIS MODAL IS NEEDED.
          // HANDLING DRAWING INCENTIVES if user searches from within this modal.
          self.drawIncentives = function (obj) {
          // console.log('DRAW INCENTIVES', obj);
          // FORCE ARRAY FOR LOOSE OBJECTS, FOR HANDLING LATER.
            if (!obj.incentives.length) {
              var iobj = obj.incentives;
              var temp = [];
              temp.push(iobj);
              obj.incentives = null;
              obj.incentives = temp;
            }
            var incentivesHTML = '';
            for (var i = 0; i < obj.incentives.length; i++) {
              var item = obj.incentives[i];

              // crate html structures.
              if (item.subTitle && item.subTitle.length) {
                item.subTitle = $.parseHTML(item.subTitle)[0].textContent;
              }

              if (item.description && item.description.length) {
                item.description = $.parseHTML(item.description)[0].textContent;
              } else {
              // FORCE DESCRIPTION
                item.description = '';
              }

              // ADD ICON CLASS.
              var iconClass = '';
              // icon-incentives-electricity icon-incentives-hov
              switch (item.icon) {
                case 'iconRebate':
                  iconClass = 'icon-incentives-rebate';
                  break;
                case 'iconHOV':
                  iconClass = 'icon-incentives-hov';
                  break;
                case 'iconElectricityRates':
                  iconClass = 'icon-incentives-electricity';
                  break;
                case 'iconTaxCredit':
                  iconClass = 'icon-incentives-tax-credit';
                  break;
                case 'icon-state-incentive':
                  iconClass = 'icon-state-incentive';
                  break;
                default: break;
              }
              item.iconClass = iconClass;

              // aseemble items:
              var blob = '';
              blob += '<div class="row modal-incentive-item">';
              blob += '	<div class="col-sm-2">';
              blob += '		<div class="icon ' + item.iconClass + '"></div>';
              blob += '	</div>';
              blob += '	<div class="col-sm-10">';
              blob += '		<h2>' + item.title + '</h2>';
              blob += '		<div>' + item.subTitle + '</div>';
              blob += '		<span>' + item.description + '</span>';
              blob += '	</div>';
              blob += '</div>';


              // MOBILE ITEMS, NEED TO BREAK UP THE CONTENT.
              blob += '<div class="row modal-incentive-item-sm">';
              blob += '	<div class="col-sm-12">';
              blob += '		<div class="col-sm-2">';
              blob += '			<div class="icon ' + item.iconClass + '"></div>';
              blob += '		</div>';
              blob += '		<div class="col-sm-10">';
              blob += '			<h2>' + item.title + '</h2>';
              blob += '		</div>';
              blob += '	</div>';
              blob += '	<div class="col-sm-12">';
              blob += '		<div>' + item.subTitle + '</div>';
              blob += '		<span>' + item.description + '</span>';
              blob += '	</div>';
              blob += '</div>';
              incentivesHTML += blob;
            }

            $('#stateIncentivesList').empty();
            $('#stateIncentivesList').append(incentivesHTML);
          };
          // SEARCH SUBMIT BUTTON.
          $('#searchSubmitState').on('click', function (evt) {
            evt.preventDefault();

            var isZip = $('#search-state').val() === 'SELECT_STATE' ? true : false;

            if (isZip && $('#searchValueModal').val().length < 5) {
              $('#searchValueModal').addClass('invalidInput');
              return;
            }

            var completeSearch = function () {
              var foundresults = false;
              for (var prop in VehicleBenefits.stateIncentives) {
                var item = VehicleBenefits.stateIncentives[prop];
                if (VehicleBenefits.selectedStateAbbr === item.stateName) {
                  foundresults = true;
                  self.drawIncentives(item);
                // break;
                }
              }

              if (!foundresults) {
                self.drawIncentives(that.cache.emptyStateItem);
              }
            };

            if (!isZip && VehicleBenefits.selectedStateAbbr !== undefined) {
              completeSearch();
              return;
            }

            if (isZip && $('#searchValueModal').val().length === 5) {
              $('#searchValueModal').addClass('validInput');
              $.ajax({
                type: 'POST',
                url: 'https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyDs2iYTroHjB8l7zbfHyWUec2cpESSIVK8&address=' + $('#searchValueModal').val(),// +'?key=AIzaSyA2qKgtN9nLVLgX_qv2GJ8c8WG7K6CbcHQ',
                success: (function () {
                  return function (data) {
                  // console.log(' >>> MAP ReSPONSE', data);
                  // var matchTypes = '["administrative_area_level_1", "political"]';
                    if (data['status'] === 'OK') {
                      var addressComponentsGrepResults = $.grep(data.results[0].address_components, function (element, index) {
                        return (-1 < $.inArray('administrative_area_level_1', element.types));
                      });
                      if (addressComponentsGrepResults && addressComponentsGrepResults.length) {
                        VehicleBenefits.selectedStateAbbr = addressComponentsGrepResults[0].short_name;
                        completeSearch();
                        return;
                      }
                    }
                  };
                })()
              });
            }
          });
        });
    },

    /*
      MLP CONTENT (https://www.toyota.com/priusprime/)):
      PriusPrimeMLP
      https://www.toyota.com/ToyotaSite/rest/lscs/getDocument?templatePath=templatedata/TComRefresh/PriusPrimeMLP/data/2017/priusprime.xml

      TCO CONTENT: (https://www.toyota.com/priusprime/calculator/):
      PriusPrimeTCO
      https://www.toyota.com/ToyotaSite/rest/lscs/getDocument?templatePath=templatedata/TComRefresh/PriusPrimeTCO/data/2017/priusprime.xml

      BENEFITS MODAL CONTENT (https://www.toyota.com/priusprime/calculator/incentives-modal):
      PriusPrimeIncentivesModal
      https://www.toyota.com/ToyotaSite/rest/lscs/getDocument?templatePath=templatedata/TComRefresh/PriusPrimeIncentivesModal/data/2017/priusprime.xml

      INCENTIVES:
      PriusPrimeIncentives
      https://test.newengland.aws.buyatoyota.com/ToyotaSite/rest/lscs/getDocument?templatePath=templatedata/TComRefresh/PriusPrimeIncentives/data/2017/priusprime.xml

    */
    requestDistance: function (startVal, destVal, callback) {
      googleMaps()
        .then(function (google) {
          var service = new google.maps.DistanceMatrixService();
          service.getDistanceMatrix({
            origins: [startVal],
            destinations: [destVal],
            travelMode: google.maps.TravelMode.DRIVING,
            unitSystem: google.maps.UnitSystem.IMPERIAL
          }, callback);
        })
        .catch(function (err) { console.warn('google maps err: ', err); });
    },

    /*
      available keys:
      PriusPrimeMLP
      PriusPrimeTCO
      PriusPrimeIncentivesModal
      PriusPrimeIncentives
    */
    getContent: function (key) {
      var self = this;
      var protocol = 'https://';
      var hostname = window.location.host;
      var endpoint = '/ToyotaSite/rest/lscs/getDocument?templatePath=templatedata/TComRefresh/' + key + '/data/2018/priusprime.xml';
      if (langFromUrl() === 'es') {
        endpoint += '?language=espanol';
      }
      var promiseObj = $.Deferred();
      $.ajax({
        type: 'GET',
        url: protocol + hostname + endpoint,
        jsonp: true
      }).done(function (data) {
        var stateAbbr = tdaUtils.getStateAbbr(unescape(storageUtil.getState()));
        var returnObj = {};
        switch (key) {
          case 'PriusPrimeMLP':
            returnObj = data.Root;
            returnObj.tco.calculator.CTA.title = langFromUrl() === 'es' ? 'Calcular mis ahorros' : 'Calculate My Savings';
            break;
          case 'PriusPrimeTCO':
            returnObj = data.Root;// .tcoIncentives.national;
            break;
          case 'PriusPrimeIncentives':
            returnObj.national = data.Root.tcoIncentives.national;
            self.cache.national = data.Root.tcoIncentives.national;
            var foundInitialStateIncentives = false;
            $.each(data.Root.tcoStateIncentives, function (index, item) {
              if (item.stateName === '') {
                item.incentives.iconClass = item.incentives.icon;
                self.cache.emptyStateItem = item;
              }
              if (item.stateName === stateAbbr) {
                if (item.stateName === '') {
                  self.noStateDetected = true; // USED IN VEHICLE INFO TO MODIFY DISPLAY CLASSES.
                }
                returnObj.state = item;
                foundInitialStateIncentives = true;
              }
            });
            if (!foundInitialStateIncentives) {
              // THE INITIAL STATE OBJECT DOES NOT EXIST, PASS BACK EMPTY.
              // THE ACTUAL MODAL MAY INCLUDE additional state incentives.
              self.noStateDetected = true; // HELPS UPDATE DISPLAY FOR NO STATE. see vehicle-info.js
              returnObj.state = self.cache.emptyStateItem;
            }
            break;
          // THE INCENTIVES MODAL CONTENT.
          case 'PriusPrimeIncentivesModal':
            // SOME OF THESE STATES HAVE SINGLE ITEMS NOT IN ARRAY,
            // FORCE TO ARRAY FOR TEMPLATE ITERATIONS.
            $.each(data.Root.stateIncentives, function (index, sobj) {
              if (!sobj.incentives.length) {
                // SINGLE ITEMS COME BACK AS OBJECTS, NEED TO PUSH INTO ARRAY.
                // console.log(' >>> FORCE TO ARRAY FOR >>>', sobj.stateName);
                var resultobj = sobj.incentives;
                var temp = [];
                temp.push(resultobj);
                sobj.incentives = temp;
              }
            });
            VehicleBenefits.stateIncentives = data.Root.stateIncentives;
            returnObj.chargePointIncentive = self.cache.chargePointIncentive;
            returnObj.content = data.Root.content;
            returnObj.federalIncentives = data.Root.federalIncentives;
            returnObj.federalIncentivesSection = data.Root.federalIncentivesSection;
            returnObj.stateIncentivesSection = data.Root.stateIncentivesSection;

            // FEDERAL INCENTIVE ITEMS.
            // single items in incentvies appear to just be an object, needs to be forced into array.
            if (!data.Root.federalIncentives.length) {
              // SINGLE ITEMS COME BACK AS OBJECTS, NEED TO PUSH INTO ARRAY.
              var federalobj = data.Root.federalIncentives;
              var temp = [];
              temp.push(federalobj);
              returnObj.federalIncentives = temp;
            }
            // console.log(' ::: FORCE FEDERAL SINGLE ITEM TO ARRAY.', data.Root.federalIncentives);
            $.each(returnObj.federalIncentives, function (index0, item0) {
              item0.subTitle = $.parseHTML(item0.subTitle)[0].textContent;
              item0.description = $.parseHTML(item0.description)[0].textContent;
              var iconClass = '';
              // icon-incentives-electricity icon-incentives-hov
              switch (item0.icon) {
                case 'iconRebate':
                  iconClass = 'icon-incentives-rebate';
                  break;
                case 'iconHOV':
                  iconClass = 'icon-incentives-hov';
                  break;
                case 'iconElectricityRates':
                  iconClass = 'icon-incentives-electricity';
                  break;
                case 'iconTaxCredit':
                  iconClass = 'icon-incentives-tax-credit';
                  break;
                default: break;
              }
              item0.iconClass = iconClass;
            });

            // STATE INCENTIVE ITEMS.
            var foundState = '';
            $.each(data.Root.stateIncentives, function (index, sobj) {
              if (sobj.stateName === stateAbbr) {
                foundState = stateAbbr;
                $.each(sobj.incentives, function (index2, item2) {
                  item2.subTitle = $.parseHTML(item2.subTitle)[0].textContent;
                  item2.description = $.parseHTML(item2.description)[0].textContent;
                  var iconClass = '';
                  // icon-incentives-electricity icon-incentives-hov
                  switch (item2.icon) {
                    case 'iconRebate':
                      iconClass = 'icon-incentives-rebate';
                      break;
                    case 'iconHOV':
                      iconClass = 'icon-incentives-hov';
                      break;
                    case 'iconElectricityRates':
                      iconClass = 'icon-incentives-electricity';
                      break;
                    case 'iconTaxCredit':
                      iconClass = 'icon-incentives-tax-credit';
                      break;
                    default: break;
                  }
                  item2.iconClass = iconClass;
                });
                returnObj.stateIncentives = sobj;
              }
            });

            if (!foundState || foundState === '') {
              var temp = [];
              temp.push(self.cache.emptyStateItem.incentives);
              returnObj.stateIncentives = { incentives: temp };
            }
            break;
          default: break;
        }
        promiseObj.resolve(returnObj);
      }).fail(function (jqXHR, textStatus, errorThrown) {
        console.error('BENEFITS FAIL: ', textStatus + errorThrown);
        promiseObj.reject();
      });

      return promiseObj.promise();
    }
  };

  return VehicleBenefits;
});

